module.exports = __webpack_public_path__ + "static/media/CloudStrife.b4e51342.png";